// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_d2c","cls2":"FeedbackModal-cls2_80F FeedbackModal-cls1_d2c"};